export function createAtlAttributionHeader({
	atlWorkspaceId,
	tenantId,
	product,
}: {
	atlWorkspaceId: string;
	tenantId: string;
	product: string;
}): {
	'atl-attribution': string;
} {
	const atlAttributionHeader = {
		atlWorkspaceId,
		tenantId,
		product,
	};
	return { 'atl-attribution': JSON.stringify(atlAttributionHeader) };
}
